/*
 * Purpose: Admin access — site + tenant role gating for /admin
 * Last modified: 2026-06-28 | Agent
 * Completeness: 94
 */
import type { AuthTenant, TenantRole } from '@/lib/auth-tenants';

const ADMIN_ROLES: TenantRole[] = ['owner', 'admin'];

function parseAdminEmails(raw: string | undefined): string[] {
  if (!raw) return [];
  return raw
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

/** Browser hint — server enforces ADMIN_EMAILS on API routes. */
export function getSiteAdminEmails(): string[] {
  return parseAdminEmails(import.meta.env.VITE_ADMIN_EMAILS);
}

export function isSiteAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return getSiteAdminEmails().includes(normalized);
}

export function isTenantAdminRole(role: TenantRole | undefined): boolean {
  return role != null && ADMIN_ROLES.includes(role);
}

export function canAccessAdmin(params: {
  email: string | null;
  activeTenant: AuthTenant | null;
}): boolean {
  const { email, activeTenant } = params;
  if (!email) return false;
  if (isSiteAdminEmail(email)) return true;
  return isTenantAdminRole(activeTenant?.role);
}
